import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/checkout.css";

const SHIPPING_FEE = 9.99;
const RESTRICTED_DESTINATIONS = ["BY", "CU", "IR", "KP", "RU", "SY"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [form, setForm] = useState({
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    address: "",
    address1: "",
    city: "",
    postalCode: "",
  });
  const [countryCode, setCountryCode] = useState("");
  const [errors, setErrors] = useState({});

  const getProductById = (id) => productData.find((product) => product.id === id);

  const subtotal = cartItems.reduce((total, item) => {
    const product = getProductById(item.id);
    return product ? total + Number(product.price) * item.quantity : total;
  }, 0);
  const total = subtotal + SHIPPING_FEE;

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const makeOrderNumber = () => {
    const random = new Uint32Array(2);
    window.crypto.getRandomValues(random);
    return `${Date.now()}${random[0]}${random[1]}`;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const nextErrors = {};
    const required = ["email", "firstName", "lastName", "address", "city", "postalCode"];
    required.forEach((field) => {
      if (!form[field].trim()) nextErrors[field] = "This field is required";
    });
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      nextErrors.email = "Enter a valid email address";
    }
    if (!countryCode) nextErrors.countryCode = "Select a delivery country";
    if (!cartItems.length) nextErrors.order = "Your cart is empty";

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    const firstProduct = getProductById(cartItems[0].id);
    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo: makeOrderNumber(),
      amount: total.toFixed(2),
      currency: "USD",
      email: form.email.trim(),
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: firstProduct?.name || "Cewillow Market order",
    });

    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="email">Contact</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={form.email}
                  placeholder="Email address"
                  onChange={updateField}
                  autoComplete="email"
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Delivery</label>
                <ReactFlagsSelect
                  selected={countryCode}
                  onSelect={setCountryCode}
                  countries={RESTRICTED_DESTINATIONS}
                  blacklistCountries
                  searchable
                  searchPlaceholder="Search countries"
                  placeholder="Select a country"
                  className="check-select"
                />
                {errors.countryCode && <p className="error">{errors.countryCode}</p>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="firstName" value={form.firstName} placeholder="First name *" onChange={updateField} autoComplete="given-name" />
                  {errors.firstName && <p className="error">{errors.firstName}</p>}
                </div>
                <div className="form-group">
                  <input type="text" name="lastName" value={form.lastName} placeholder="Last name *" onChange={updateField} autoComplete="family-name" />
                  {errors.lastName && <p className="error">{errors.lastName}</p>}
                </div>
              </div>

              <div className="form-group">
                <input type="text" name="company" value={form.company} onChange={updateField} placeholder="Company name (optional)" autoComplete="organization" />
              </div>
              <div className="form-group">
                <input type="text" name="address" value={form.address} onChange={updateField} placeholder="Address *" autoComplete="address-line1" />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>
              <div className="form-group">
                <input type="text" name="address1" value={form.address1} onChange={updateField} placeholder="Apartment, suite, etc. (optional)" autoComplete="address-line2" />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="city" value={form.city} placeholder="City *" onChange={updateField} autoComplete="address-level2" />
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
                <div className="form-group">
                  <input type="text" name="postalCode" value={form.postalCode} placeholder="Postal code *" onChange={updateField} autoComplete="postal-code" />
                  {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                </div>
              </div>

              {errors.order && <p className="error">{errors.order}</p>}
              <button className="check-checkout-button" type="submit">Pay Now</button>
            </form>

            <p>
              <Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>
                Shipping & Returns Info
              </Link>
            </p>
          </div>
        </div>

        <div className="right">
          <div className="check-order-summary">
            <div className="check-order-details">
              {cartItems.map((item, index) => {
                const product = getProductById(item.id);
                if (!product) return null;
                return (
                  <div key={`${item.id}-${item.size}-${item.color}-${index}`} className="check-cart-item">
                    <img src={product.image} alt={product.name} />
                    <div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                    <div className="check-item-details">
                      <h3>
                        {product.name}
                        {item.size && <><br />Size: {item.size}</>}
                        {item.color && <><br />Color: {item.color}</>}
                      </h3>
                    </div>
                    <p className="cal-single">
                      ${(Number(product.price) * item.quantity).toFixed(2)}
                    </p>
                  </div>
                );
              })}

              <div className="check-summary-details">
                <table className="summary-details22">
                  <tbody className="sumTbody22">
                    <tr className="sumTr22"><th className="subtotalTh22">Subtotal</th><td className="subtotalTxt22">${subtotal.toFixed(2)}</td></tr>
                    <tr className="sumTr22"><th className="subtotalTh22">Shipping</th><td className="subtotalTxt22">${SHIPPING_FEE.toFixed(2)}</td></tr>
                    <tr className="sumTr22"><th className="subtotalTh122">Total (USD)</th><td className="subtotalTxt122">${total.toFixed(2)}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CheckOut;
